export class AppSettings {
    // public static JAVA_API = 'http://localhost:8080/epas/';
    public static JAVA_API = 'https://registro-iimb-exchange.edtex.in/api/';
    public static NODE_API = 'https://registro-iimb-exchange.edtex.in/iimb/';
    // public static NODE_API = 'http://localhost:3003/';

    public static AUTHENTICATE_USER = 'authenticate';
    public static AUTHENTICATE_GOOGLE_USER = 'authenticate/google';
    //public static GET_MY_PASSWORD = 'authenticate/get-my-password/';
    public static GET_MY_PASSWORD = 'authenticate/get-my-password';
        public static RESET_PASSWORD = 'authenticate/reset-password';



    public static GET_ROUNDS_FILTER = 'round/get-rounds-filter';
    public static GET_OUTGOING_BATCH = 'student/get-outgoing-batch';
    public static GET_OUTGOING_STUDENTS = 'student/get-outgoing-students/';
    public static GET_UNIVERSITIES = 'university/get-universities';
    public static GET_OUTGOING_STUDENT_DATA_FOR_HOME = 'outgoing-student-home/get-details/';
    public static GET_PROGRAMMES = 'programme/get-programmes';
    public static GET_ACTIONS = 'actions/get-allotments';
    public static GET_OUTGOING_TERMS = 'term/get-outgoing-terms';
    public static GET_ALL_ROUND_SETTINGS = 'round/get-all-rounds';
    public static GET_DATA_TO_ADD_OUTGOING_TERMS = 'term/get-data-to-add-outgoing-terms';
    public static GET_DATA_FOR_OUTGOING_STUDENT_HOME = 'outgoing-student/get-data-for-outgoing-student-home/';
    public static GET_STATIC_DATA_FOR_BIDDING_ROUND = 'outgoing-student/get-data-for-preferences/';
    public static GET_EXPECTED_UNIVERSITY_FOR_BIDDING_ROUND = 'outgoing-student/get-expected-university-for-round/';
    public static GET_DATA_FOR_CONFIRMATION_ROUND = 'confirmation/get-data-for-confirmation-round/';
    public static GET_TERM_AND_ROUND_DETAILS = 'outgoing-student/get-term-and-round-details/'; // 30 sec call details.
    public static GET_TERMS_FOR_ROUNDS = 'round/get-data-for-rounds/';
    public static GET_DATA_TO_EDIT_TERM = 'term/get-outgoing-term-data-to-edit/';
    public static GET_BIDDING_RESULTS = 'round/get-bidding-results/';
    public static GET_PROCESSING_OUTPUT = 'round/get-processing-output/';
    public static GET_BIDDING_RESULTS_REPORT = 'report/get-bidding-results/';
    public static GET_PROCESSING_OUTPUT_REPORT = 'report/get-processing-output/';
    public static GET_OIA_HOME_DETAILS = 'home/get-continent-wise-numbers-and-summary-of-students/';
    public static GET_ROUND2_DATA = 'outgoing-term/get-outgoing-students-result/';
    public static GET_STUDENT_GIVEN_AND_NOT_GIVEN_PREFERENCES = 'outgoing-term/get-outgoing-students-preferences-for-round2/';
    public static GET_OUTGOING_STUDENT_REGISTRATION = 'outgoing-student/get-outgoing-student-registration-details/';
    public static CREATE_UPDATE_OUTGOING_STUDENT_REGISTRATION = 'outgoing-student/create-update-outgoing-student-registration';
    public static FINAL_CREATE_UPDATE_OUTGOING_STUDENT_REGISTRATION = 'outgoing-student/final-create-update-outgoing-student-registration';
    public static GET_UNIVERSITY_DETAILS_TO_EDIT = 'university/get-university-details-to-edit/';
    public static GET_REGISTERED_STUDENTS = 'oia-registration/get-registered-students/';
    public static GET_REGISTERED_STUDENT_DETAILS = 'oia-registration/get-registered-student-details/';
    public static UPDATE_STUDENT_STATUS = 'oia-registration/update-student-registration-status';
    public static UPDATE_STUDENT_REGISTRATION_DETAILS = 'oia-registration/update-student-registration-details';
    public static GENERATE_PREFERENCES = 'utility/generate-random-preferences';
    public static GET_DOCUMENT_PAGE_DATE = 'document/get-data/';
    public static GET_INCOMING_STUDENT_DOCUMENT_DATA = 'document/get-incoming-student-data/';
    public static DOWNLOAD_DOCUMENT = 'template/download-student-document';
    public static GET_UNIVERSITY_WISE_STUDENT_LIST = 'outgoing-student/get-university-students/';
    public static VALIDATE_ALL_REGISTRATIONS = 'oia-registration/accept-all-outgoing-student-registrations/';
    public static GET_FEEDBACK_QUESTIONS = 'feedback/get-feedback-questions/';
    public static UPLOAD_OUTGOING_STUDENT_FEEDBACK = 'feedback/create-outgoing-student-feedback/';
    public static GET_NOMINATIONS = 'nomination/get-nominations/';
    public static GET_INCOMING_TERM_SETTINGS = 'incoming-term/get-incoming-term-settings';
    public static GET_DATA_TO_ADD_INCOMING_TERM_SETTINGS = 'incoming-term/get-data-to-add-incoming-term-settings';
    public static GET_DATA_TO_EDIT_INCOMING_TERM_SETTINGS = 'incoming-term/get-data-to-edit-incoming-term-settings/';
    public static GET_INCOMING_STUDENT_HOME_DETAILS = 'incoming-student/get-incoming-student-home-details/';
    public static GET_POC_HOME_DETAILS = 'poc/get-poc-home-details/';
    public static GET_INCOMING_STUDENT_REGISTRATION_DETAILS = 'incoming-student/get-incoming-student-registration-details/';
    public static GET_INCOMING_REGISTRATIONS = 'oia/get-incoming-registrations/';
    public static CHANGE_DREAM_UNIVERSITY = 'outgoing-student/change-dream-university/';
    public static CONFIRM_UNIVERSITY = 'confirmation/confirm-university/';
    public static UN_CONFIRM_UNIVERSITY = 'confirmation/un-confirm-university/';
    public static OPT_OUT_FROM_EXCHANGE = 'confirmation/opt-out/';
    public static SELECT_PREVIOUS_ROUND_PREFERENCES = 'outgoing-student/select-previous-round-preferences/';
    public static GET_ALL_INCOMING_POCS = 'poc/get-all-incoming-pocs/';

    public static GET_ACADEMIC_YEAR = 'report/get-academic-year/';
    public static GET_STUDENT_RANKS_FOR_REPORT = 'report/get-outgoing-student-ranks/';
    public static GET_STUDENT_REGISTRATION_STATUS_FOR_REPORT = 'report/get-outgoing-student-registration-status/';
    public static GET_PRACTICE_ROUND_UNIVERSITY_PREFERENCES = 'report/get-outgoing-student-practice-round-preferences/';
    public static GET_UNIVERSITY_PREFERENCES = 'report/get-outgoing-student-preferences/';
    public static GET_OUTGOING_PRACTICE_ROUND_ALLOTMENT_DETAILS = 'report/get-outgoing-practice-round-allotment-details/';
    public static GET_OUTGOING_ALLOTMENT_DETAILS = 'report/get-outgoing-allotment-details/';
    public static GET_ROUND_TWO_ALLOTMENT = 'report/get-round-two-allotment-details/';
    public static GET_FINAL_UNIVERSITY_ALLOTMENT = 'report/get-final-university-allotment/';
    public static GET_FINAL_UNIVERSITY_WISE_ALLOTMENT_REPORT = 'report/get-final-university-wise-allotment-report/';
    public static GET_DIVERSITY_REPORT = 'report/get-diversity-report/';
    public static GET_BALANCE_OF_TRADE_REPORT = 'report/get-balance-of-trade-report/';
    public static GET_FINAL_OPTED_OUT_STUDENTS_REPORT = 'report/get-opted-out-students/';


    public static DOWNLOAD_ROUND_WISE_BIDDING_RESULTS = AppSettings.NODE_API + 'download/download-round-wise-bidding-results/';
    public static DOWNLOAD_ROUND_WISE_PROCESSING_OUTPUT = AppSettings.NODE_API + 'download/download-round-wise-processing-output/';
    public static DOWNLOAD_OUTGOING_STUDENT_REGISTRATION_STATUS = AppSettings.NODE_API
        + 'download/download-outgoing-student-registration-status/';
    public static DOWNLOAD_OUTGOING_STUDENT_RANKS = AppSettings.NODE_API + 'download/download-outgoing-student-ranks/';
    public static DOWNLOAD_PRACTICE_ROUND_UNIVERSITY_PREFERENCES =
        AppSettings.NODE_API + 'download/download-outgoing-student-practice-round-preferences/';
    public static DOWNLOAD_UNIVERSITY_PREFERENCES = AppSettings.NODE_API + 'download/download-outgoing-student-preferences/';
    public static DOWNLOAD_OUTGOING_PRACTICE_ROUND_ALLOTMENT_REPORT =
        AppSettings.NODE_API + 'download/download-practice-round-university-wise-allotment-report/';
    public static DOWNLOAD_OUTGOING_ALLOTMENT_REPORT = AppSettings.NODE_API + 'download/download-university-wise-allotment-report/';
    public static DOWNLOAD_ROUND_TWO_ALLOTMENT =
        AppSettings.NODE_API + 'download/download-round-two-allotment-details/';
    public static DOWNLOAD_FINAL_UNIVERSITY_ALLOTMENT =
        AppSettings.NODE_API + 'download/download-final-university-allotment/';
    public static DOWNLOAD_FINAL_UNIVERSITY_WISE_ALLOTMENT_DETAILS =
        AppSettings.NODE_API + 'download/download-final-university-wise-allotment-report/';
    public static DOWNLOAD_FINAL_OPTED_OUT_STUDENTS_REPORT =
        AppSettings.NODE_API + 'download/download-final-opted-out-students-report/';
    public static DOWNLOAD_DIVERSITY_REPORT = AppSettings.NODE_API + 'download/download-diversity-report/';
    public static DOWNLOAD_BALANCE_OF_TRADE_REPORT = AppSettings.NODE_API + 'download/download-balance-of-trade-report/';
    public static DOWNLOAD_FEEDBACK_REPORT = AppSettings.NODE_API + 'download/download-feedback-report/';
    public static DOWNLOAD_PASSWORDS = AppSettings.NODE_API + 'utility/download-outgoing-student-passwords/';

    public static CREATE_OR_UPDATE_PREFERENCE = 'outgoing-student/create-or-update-preferences/';
    public static DELETE_PREFERENCES = 'outgoing-student/delete-preferences/';
    public static GENERATE_RANKS = 'oia/generate-ranks';
    public static GENERATE_RESULTS = 'oia/generate-results';
    public static MODIFY_ROUND2_UNIVERSITY = 'outgoing-term/modify-round2-university-for-student';
    public static DELETE_EXPERIENCE = 'outgoing-student/delete-work-experience';
    public static CLEAR_RANKS = 'oia/clear-ranks';
    public static CLEAR_RESULTS = 'oia/clear-results';
    public static SEND_ROUND_RESULT = 'mail/send-round-result-to-students';

    public static UPLOAD_OUTGOING_STUDENTS = 'student/upload-outgoing-students';
    public static UPLOAD_UNIVERSITIES = 'university/upload-universities';
    public static UPLOAD_IIMB_EMAILS = 'oia/upload-iimb-emails';
    public static EDIT_UNIVERSITY = 'university/edit-university';
    public static UPLOAD_ACTIONS = 'actions/upload-allotments';
    public static TOGGLE_FAVOURITE = 'outgoing-student-home/toggle-favourite';
    public static ADD_TERMS = 'term/add-outgoing-terms';
    public static EDIT_TERMS = 'term/edit-outgoing-terms';
    public static ADD_ROUNDS = 'round/add-outgoing-rounds';
    public static UPDATE_ROUND_SETTINGS = 'round/update-outgoing-rounds';
    public static UPLOAD_OUTGOING_TERM_SETTINGS = 'term/upload-outgoing-term-settings';
    public static UPLOAD_PAST_DATA = 'utility/upload-past-data';

    public static DOCUMENT_UPLOAD = 'document/file-upload';
    public static UPLOAD_FS_OR_MOU_FILE = 'document/save-fs-or-mou-document';
    public static DELETE_FS_OR_MOU_DOCUMENT = 'document/delete-fs-or-mou-document';
    public static UPLOAD_INCOMING_STUDENT_FILE = 'document/save-incoming-student-document';
    public static DELETE_INCOMING_STUDENT_FILE = 'document/delete-incoming-student-document';
    public static DELETE_OUTGOING_STUDENT_FILE = 'document/delete-outgoing-student-document';

    public static CLEAR_OUTGOING_STUDENTS = 'student/clear-outgoing-students';
    public static CLEAR_UNIVERSITIES = 'university/clear-universities';
    public static CLEAR_ACTIONS = 'actions/clear-allotments';
    public static CLEAR_TERMS = 'term/clear-terms';
    public static CLEAR_ALL = 'utility/clear-all';

    public static MODIFY_OUTGOING_STUDENT = 'student/update-outgoing-student';
    public static MODIFY_UNIVERSITY = 'university/update-university';
    public static MODIFY_TERMS = 'term/update-terms';

    public static DELETE_POC = 'university/delete-poc';
    public static DELETE_ROUND = 'round/delete-outgoing-round';
    public static ADD_NOMINATION = 'nomination/add-nomination';
    public static EDIT_NOMINATION = 'nomination/edit-nomination';
    public static CHANGE_STUDENT_STATE = 'nomination/change-student-state';
    public static SEND_NOMINATION_EMAIL = 'nomination/send-email-nomination';
    public static CREATE_OR_UPDATE_INCOMING_TERM_SETTINGS = 'incoming-term/create-or-modify-incoming-term-settings';
    public static DELETE_INCOMING_TERM_SETTINGS = 'incoming-term/delete-incoming-term-settings/';
    public static UPDATE_INCOMING_STUDENT_REGISTRATION = 'incoming-student/update-incoming-student-registration/';
    public static FINAL_UPDATE_INCOMING_STUDENT_REGISTRATION = 'incoming-student/final-update-incoming-student-registration';
    public static ACCEPT_NOMINATION = 'oia/accept-nomination';
    public static REJECT_NOMINATION = 'oia/reject-nomination';
    public static LOGIN_DETAILS_TO_POC = 'mail/send-poc-login-details';
    public static LOGIN_DETAILS_TO_POC_BY_POC_ID = 'mail/send-poc-login-details-by-poc-id';

    public static OUTGOING_STUDENT_TEMPLATE = AppSettings.NODE_API + 'template/get-outgoing-student-template?token=';
    public static IIMB_EMAILS_TEMPLATE = AppSettings.NODE_API + 'template/get-iimb-emails-template?token=';
    public static UNIVERSITY_TEMPLATE = AppSettings.JAVA_API + 'template/get-university-template';
    public static PROGRAMME_TEMPLATE = AppSettings.NODE_API + 'template/get-programme-template';

    public static DOWNLOAD_NOMINATIONS = AppSettings.JAVA_API + 'download/download-nominations/';
    public static DOWNLOAD_ISSUANCE_OF_STUDENT_VISA = AppSettings.JAVA_API + 'download/download-issuance-of-student-visa/';
    public static DOWNLOAD_NOC_DOCUMENT = AppSettings.JAVA_API + 'download/download-noc-document/';
    public static DOWNLOAD_LETTER_OF_ADMISSION = AppSettings.JAVA_API + 'download/download-letter-of-admission/';
    public static DOWNLOAD_REGISTRATIONS = AppSettings.JAVA_API + 'download/download-incoming-registrations/';
    public static DOWNLOAD_REGISTRATIONS_CSV = AppSettings.JAVA_API + 'download/download-incoming-registrations-csv/';
    public static DOWNLOAD_INCOMING_STUDENT_DOCUMENT = 'download/download-incoming-student-document';
	public static DOWNLOAD_FACTSHEET_DOCUMENT = 'download/download-factsheet-document';
    public static DOWNLOAD_POC_PASSWORDS = AppSettings.JAVA_API + 'download/download-poc-passwords/';
    public static DOWNLOAD_INCOMING_STUDENT_DOCUMENTS = 'download/download-incoming-students-documents';
    public static DOWNLOAD_OUTGOING_STUDENT_DOCUMENTS = 'download/download-outgoing-students-documents';

    public static UNIVERSITIES_BY_OUTGOING_ROUND_ID ='outgoing/get-universities-for-outgoing-round/';
    public static STUDENTS_BY_OUTGOING_ROUND_ID ='outgoing/get-students-for-outgoing-round/';
    public static ADD_STUDENT_TO_BIDDING_RESULTS = 'outgoing/add-students-for-outgoing-round-results';

    public static GET_INCOMING_TERM_VISA_SETTINGS = 'incoming-term-visa-settings/get-incoming-term-visa-settings';
    public static GET_ALL_ACADEMIC_YEARS = 'incoming-term-visa-settings/get-all-academic-years';
    public static GET_INCOMING_TERM_VISA_SETTINGS_BY_ID = 'incoming-term-visa-settings/get-incoming-student-visa-settings-for-incoming-term/';

    public static UPDATE_INCOMING_TERM_VISA_SETTING = 'incoming-term-visa-settings/update-incoming-student-visa-settings';
    public static ADD_INCOMING_TERM_VISA_SETTING = 'incoming-term-visa-settings/create-incoming-student-visa-settings';
    public static GET_INCOMING_TERM_SETTINGS_FOR_VISA = 'incoming-term-visa-settings/get-incoming-term-settings-for-visa-settings';

    public static DOWNLOAD_ACCEPTED_ADMISSION_LETTERS = 'download/download-accepted-incoming-students-admission-documents';
    public static INCOMING_STUDENT_REGISTRATION_BY_TERM_ID = 'incoming-student/get-incoming-student-registration-details-term-id';

    public static GET_DREAM_UNIVERSITY_PREFERENCES = 'report/get-dream-university-preferences/';
    public static DOWNLOAD_DREAM_UNIVERSITY_PREFERENCES =
        AppSettings.NODE_API + 'download/download-dream-university-list/';
	

}
